import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../../styles/FontStyles';

import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioPoolTicket,
  IconPortfolioRevenue,
  IconPortfolioStaked
} from '../../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from '../Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../app/hooks';
import { formatUSD, USDT } from '../../../helpers/helperFunctions';
import { getMyHubsSuperSales } from '../Portfolio.actions';

import { SUPER_SALES } from '../../../routes/routes';

import Spinner from '../../../components/common/Spinner';
import { SuperSalesItem } from './SuperSalesItem';

export const SuperSalesSummary = () => {
  const dispatch = useDispatch();

  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { superSales, loadingSummary } = useAppSelector(
    (state) => state.portfolio
  );

  useEffect(() => {
    dispatch(getMyHubsSuperSales());
  }, [dispatch]);

  return (
    <div style={{ marginBottom: 40 }}>
      <Flexed mb='20' center between>
        <H3>My Super Sales License Summary</H3>
      </Flexed>

      <SummaryGrid columns>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total Super Sales orders
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(superSales?.summary?.totalOrderAmount)}
              <P3 mb='1'>{USDT}</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <SummaryGrid columns>
        {/* <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Super sales pool ticket
            </CaptionText>
            
            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.silverPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.silverPoolTickets === '1'
                  ? 'Ticket'
                  : 'Tickets'}
              </P3>
            </P1>
          </div>
        </BoxPortfolio> */}
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              founders pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {superSales?.summary?.foundersPoolTickets}
              <P3 mb='1'>
                {superSales?.summary?.foundersPoolTickets === 1
                  ? 'Ticket'
                  : 'Tickets'}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <div style={{ position: 'relative' }}>
        {loadingSummary && <Spinner absolute transparent />}
      </div>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>My Super Sales License Summary</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>

        <Button
          negative
          maxWidth='350px'
          maxWidthSM='100%'
          onClick={() => history.push(SUPER_SALES)}>
          ADD SUPER SALES LICENCE
        </Button>
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {superSales?.userPackages?.map((item: any, i: number) => (
            <SuperSalesItem key={i} item={item} />
          ))}
        </div>
      </Collapsable>
    </div>
  );
};
